import Head from 'next/head';

import Page from 'components/Page';
import Blog from 'blog/templates/Blog';
import NotFound from 'components/NotFoundPage/NotFound';
import ErrorBoundary from 'components/ErrorBoundary';

import { cmsGetBlogArticleByTag, cmsGetBlogArticleByUid } from 'api/cms';
import { buildArticleJsonLd } from 'utils/buildJsonLd';

export const getServerSideProps = async (context) => {
  const { uid } = context.query;

  try {
    const blog = await cmsGetBlogArticleByUid(uid, 1);
    const related = await cmsGetBlogArticleByTag('formations', '5');

    const [article] = blog.data;
    const categoryUid = article?.articleData?.category?.uid;

    // Check if the query category uid matches with the one in the article
    if (categoryUid !== context.query.category) {
      return {
        notFound: true,
      };
    }

    const jsonLd = buildArticleJsonLd({ article: blog.data, uid });

    if (!blog?.data) {
      return {
        notFound: true,
      };
    }

    if (!related) {
      return {
        props: {
          article: blog.data,
          uid: uid,
          jsonLd: jsonLd,
        },
      };
    }

    return {
      props: {
        article: blog.data,
        uid: uid,
        related: related,
        jsonLd: jsonLd,
      },
    };
  } catch (error) {
    console.error('Error in getServerSideProps:', error);
    return {
      notFound: true,
    };
  }
};

const Article = (props) => {
  const { uid, article, jsonLd, related } = props;
  const [articleObj] = article;

  if (!article) {
    return <NotFound />;
  }

  const meta = {
    description: articleObj?.articleData?.metaData.description,
    title: articleObj?.articleData?.metaData.title,
    image: articleObj?.articleData?.metaData.image.img.url || null,
  };

  const product = articleObj?.articleData?.productType?.product;

  return (
    <>
      {jsonLd && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(jsonLd),
            }}
          />
        </Head>
      )}
      <Page
        background="white"
        meta={meta}
        key={article.id}
        showSearch
        serviceName="Blog"
        product={product}
      >
        <ErrorBoundary componentName="BlogArticle">
          <Blog article={article} related={related} uid={uid} />
        </ErrorBoundary>
      </Page>
    </>
  );
};

export default Article;
